import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

// Usa .chip + .chip-* direto de ui/styles/legacy.css.
// Tons: neutral→.chip-muted, ok→.chip-ok, warn→.chip-warn, danger→.chip-danger,
// info→.chip-blue. Accent não existe no legacy — Tailwind custom.
const chip = cva('chip', {
  variants: {
    tone: {
      neutral: 'chip-muted',
      ok: 'chip-ok',
      warn: 'chip-warn',
      danger: 'chip-danger',
      info: 'chip-blue',
      accent: '!bg-[var(--accent-soft)] !text-accent !border-none',
    },
    size: {
      sm: 'text-[0.7rem] px-2 py-[1px]',
      md: '',
    },
  },
  defaultVariants: { tone: 'neutral', size: 'md' },
});

export interface ChipProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof chip> {
  dot?: boolean;
}

export const Chip = forwardRef<HTMLSpanElement, ChipProps>(function Chip(
  { tone, size, dot, className, children, ...rest },
  ref,
) {
  return (
    <span ref={ref} className={cn(chip({ tone, size }), className)} {...rest}>
      {dot && (
        <span
          className="inline-block rounded-full bg-current align-middle mr-1"
          style={{ width: 6, height: 6 }}
        />
      )}
      {children}
    </span>
  );
});
